import "./Common.scss";
import clsx from "clsx";

const ColoredAmount = ({amount, children, className}) => {
  let clazz = null;

  if (amount > 0) {
    clazz = "positive";
  } else if (amount < 0) {
    clazz = "negative";
  }

  return (
    <span className={clsx(className, "amount", clazz)}>{children}</span>
  );
};

export default ColoredAmount;
